import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import classes from './style.module.css';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import InputText from './components/InputText';
import CheckboxSwitch from './components/CheckboxSwitch';
import { setPostNewProviders } from '../../../store/games/thunk/setPostNewProviders';

const CreateProviders = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    const handleClick = () => {
        router.history.push('/providers/list')
    }

    const { register, handleSubmit, control } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            name: '',
            is_deleted: false,
            is_disabled: true
        },
    });

    const callbackSuccess = () => {
        alert("Сохранено");
        router.history.push('/games/list')
    }

    const onSubmit = (store) => {
        dispatch(setPostNewProviders(store, callbackSuccess));
    }

    return (
        <div className={classes.root}>
            <Title
                label="Создать провайдера"
                labelBtn="Назад"
                button={handleClick}
            />
            <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
                <InputText
                    name="name"
                    register={register}
                    label="Название"
                    placeholder="Название"
                />
                <div className={classes.form__wrap_switch}>
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_deleted"
                        label="Признак удаленности"
                    />
                    <CheckboxSwitch
                        register={register}
                        control={control}
                        name="is_disabled"
                        label="Признак отключения"
                    />
                </div>
                <div className={classes.form__wrap_submit}>
                    <button type="submit" className={classes.submit}>
                        <span>Сохранить</span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default CreateProviders;